import { createSlice } from "@reduxjs/toolkit";

import {
  fetchChartLinesAsync,
  fetchChartsAsync,
  fulfilledFetchChartLinesAsync,
  fulfilledFetchChartsAsync,
  pendingFetchChartLinesAsync,
  pendingFetchChartsAsync,
  rejectedFetchChartLinesAsync,
  rejectedFetchChartsAsync,
} from "../async/chartsAsync";
import Actions from "../action/chartsAction.js";

const chartsSlice = createSlice({
  name: "chartsController",
  initialState: {
    charts: null,
    chartLinesh: null,
    chartsSettings: null,
    isChartsFetching: true,
  },
  reducers: {
    ...Actions,
  },
  extraReducers: (builder) => {
    builder.addCase(fetchChartsAsync.fulfilled, fulfilledFetchChartsAsync);
    builder.addCase(fetchChartsAsync.rejected, rejectedFetchChartsAsync)
    builder.addCase(fetchChartsAsync.pending, pendingFetchChartsAsync);
    builder.addCase(fetchChartLinesAsync.fulfilled, fulfilledFetchChartLinesAsync);
    builder.addCase(fetchChartLinesAsync.rejected, rejectedFetchChartLinesAsync);
    builder.addCase(fetchChartLinesAsync.pending, pendingFetchChartLinesAsync);
  },
});

//Selectors
export const chartsData = (state) => state.chartsController.charts;
export const chartLinesData = (state) => state.chartsController.chartLines;
export const chartsSettings = (state) => state.chartsController.chartsSettings;
export const isChartsFetching = (state) => state.chartsController.isChartsFetching;

export const { setChartsSettings } = chartsSlice.actions;

export default chartsSlice.reducer;
